export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE";

export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";

export const PROFILE_USER_REQUEST = "PROFILE_USER_REQUEST";
export const PROFILE_USER_SUCCESS = "PROFILE_USER_SUCCESS";
export const PROFILE_USER_FAILURE = "PROFILE_USER_FAILURE";

export const USER_LOGOUT="USER_LOGOUT";

export const ADD_TO_CART="ADD_TO_CART"
